import {
  InstagramLogo,
  LinkedinLogo,
  TelegramLogo,
  TwitterLogo,
} from '@phosphor-icons/react'

import { InfoSquare } from './infoSquare'
import { Heading } from '../../../../Components/Screen/Text/Heading'

const size = 48

export default function BePart() {
  return (
    <section className="flex flex-col w-full text-center" id="community">
      <Heading>
        Faça parte da <Heading className="text-laranjaClaro">Farmie</Heading>
      </Heading>
      <div className="flex flex-col gap-3 w-full items-center">
        <div className="flex flex-row gap-3 mt-10">
          <InfoSquare
          // link={'https://instagram.com/'}
          >
            <InstagramLogo size={size} />
          </InfoSquare>
          <InfoSquare
          // link={'https://twitter.com/'}
          >
            <TwitterLogo size={size} />
          </InfoSquare>
        </div>
        <div className="flex flex-row gap-3">
          <InfoSquare
          // link={'https://telegram.org/'}
          >
            <TelegramLogo size={size} />
          </InfoSquare>
          <InfoSquare
          // link={'https://www.linkedin.com/'}
          >
            <LinkedinLogo size={size} />
          </InfoSquare>
        </div>
      </div>
    </section>
  )
}
